<ng-template [ngIf]="disabled">
    <input type="text" class="form-control" [value]="ngModel | tipoPromocaoCampanhaApresentacao | uppercase" disabled="disabled" readonly="readonly">
</ng-template>

<ng-template [ngIf]="!disabled">
    <select 
        #select
        class="form-control" 
        [name]="name"
        [id]="id"
        [required]="required"
        [autofocus]="autofocus"
        [ngModel]="ngModel || ''" 
        (ngModelChange)="onChange($event ? $event : null)">
        <option value="" *ngIf="canSelectNull">NÃO DETERMINADA</option>
        <option *ngFor="let tipo of tipos" [ngValue]="tipo.id">{{tipo.nomeApresentacao | uppercase}}</option>
    </select>  
</ng-template>